import React from 'react';
import { OmniDropdownComponent } from '../../../../shared/components/omni-components';
import '../../../../styles/placementLevelFilter.css';

export class PlacementLevelFilterComponent extends React.Component {
    // Class properties for drag functionality
    initialX = 0;
    initialY = 0;
    xOffset = 0;
    yOffset = 0;
    
    constructor(props) {
        super(props)
        this.state = {
            channelDropDown: [],
            supplierDropDown: [],
            packageDropDown: [],
            placementDropDown: [],
            lineItemDropDown: [],
            creativeDropDown: [],
            isShowLineItem: true,
            isShowPlacement: true,
            isApplyDisabled: true,
            isShowPopup: false,
            isDragging: false
        }
        this.containerRef = React.createRef();
    }

    filterData = [];
    selectedFieldValues = {'channel': [], 'budgetType': '', 'supplier': [], 'inPlatform': '', 'package': [], 'placement': [], 'line': [], 'creative': []};


    // Lifecycle methods
    componentDidMount() {
        this.setFilterData();
    }

    // Lifecycle methods
    componentDidUpdate(prevProps) {
        if(prevProps.isOpen !== this.props.isOpen){
            this.setState({isShowPopup: this.props.isOpen});
        }
        if(prevProps.placementData !== this.props.placementData){
            this.setFilterData();
            if(this.props.isFilterOn){
                this.onApply();
            }
        }
    }

    /**
     * This method is used to set/refresh the filter data based on the placement data
     * and create dropdown options for each level of filter
     * @returns void
    */
    setFilterData = () => {
        let allPlacmentList = [...this.props.placementData];
        let deliveredTaxonomies = [];
        allPlacmentList.forEach(placement => {
            placement.placement_type = placement.placement_type ? placement.placement_type : 'Unassigned';
            placement.site = (placement.site && placement.site !== 'NU' ? placement.site : 'Unassigned').toUpperCase();
            if(placement?.delivered_taxonomies?.length){
                placement?.delivered_taxonomies?.forEach(deliveredPlacement=>{
                    let obj = {
                        placement_taxonomy: deliveredPlacement?.taxonomy_value,
                        package_type: "Delivered",
                        parameter_code: "",
                        adVerifiactionBudget: "",
                        adServingBudget: "",
                        flight_start: "",
                        flight_end: "",
                        unit_amount: "",
                        rate: "",
                        parent_id:placement.id,
                        export_status: deliveredPlacement?.status,
                        site: placement?.site,
                        placement_type:placement?.placement_type,
                        taxonomy_schema_id: deliveredPlacement?.taxonomy_schema_id,
                        taxonomy_schema: deliveredPlacement?.taxonomy_schema,
                        taxonomy_value_id: deliveredPlacement?.taxonomy_value_id,
                        id: deliveredPlacement?.taxonomy_value_id,
                        leftbar: "#2CC4AD",
                    }
                    deliveredTaxonomies.push(obj);
                });
            }
        });

        this.filterData = [...allPlacmentList,...deliveredTaxonomies];
        this.createDropdownsOptions(this.filterData, 'NONE');
    }

    /**
    * This method is used to create dropdown options for each level of filter
    * and set the state of based on the filter type
    * @param filterData: Array of filter data
    * @param filterType: Type of filter
    * @returns void
    */
    createDropdownsOptions = (filterData, filterType) => {
        let channelList = [];
        let supplierList = [];
        let packageList = [];
        let placementList = [];
        let lineItemList = [];
        let creativeList = [];
        let isPackageOn = false;
        let isProgrammaticOn = false;
        for(let i=0; i<filterData.length; i++) {
            if(filterData[i].id){
                let placementType = filterData[i].placement_type ? filterData[i].placement_type : 'Unassigned';
                let site = (filterData[i].site ? filterData[i].site : 'Unassigned').toUpperCase();
                if(!channelList.includes(placementType))
                    channelList.push(placementType);

                if(!supplierList.includes(site))
                    supplierList.push(site);

                if(filterData[i].package_type === "Package"){
                    isPackageOn = true;
                    isProgrammaticOn = false;
                    filterData[i].dropdownType = "Package";
                    packageList.push(filterData[i].placement_taxonomy);
                }
                else if(filterData[i].package_type === "ProgrammaticPackage"){
                    isPackageOn = false;
                    isProgrammaticOn = true;
                    filterData[i].dropdownType = "Package";
                    packageList.push(filterData[i].placement_taxonomy);
                }
                else if(filterData[i].package_type === "DSP"){
                    filterData[i].dropdownType = "DSP";
                    lineItemList.push(filterData[i].placement_taxonomy);
                } else if(filterData[i].package_type === "Child" && isPackageOn){
                    filterData[i].dropdownType = "Placement";
                    placementList.push(filterData[i].placement_taxonomy);
                } else if(filterData[i].package_type === "Child" && isProgrammaticOn || (filterData[i].package_type == 'DirectCreative' || filterData[i].package_type == "Delivered")){
                    filterData[i].dropdownType = "Creative";
                    creativeList.push(filterData[i].placement_taxonomy);
                } else if(filterData[i].package_type === "Standalone"){
                    filterData[i].dropdownType = "Placement";
                    placementList.push(filterData[i].placement_taxonomy);
                    isPackageOn = false;
                    isProgrammaticOn = false;
                }
                else if(filterData[i].package_type === "SearchOrder"){
                    filterData[i].dropdownType = "Placement";
                    placementList.push(filterData[i].placement_taxonomy);
                    isPackageOn = false;
                    isProgrammaticOn = false;
                }
            }

            
        }
        if(filterType === 'NONE'){
            this.setState({channelDropDown: channelList, supplierDropDown: supplierList, packageDropDown: packageList, placementDropDown: placementList, lineItemDropDown: lineItemList, creativeDropDown: creativeList});
        } else if (filterType === 'channel') {
            this.setState({supplierDropDown: supplierList, packageDropDown: packageList, placementDropDown: placementList, lineItemDropDown: lineItemList, creativeDropDown: creativeList});
        } else if (filterType === 'supplier' || filterType === 'budgetType' || filterType === 'inPlatform') {
            this.setState({packageDropDown: packageList, placementDropDown: placementList, lineItemDropDown: lineItemList, creativeDropDown: creativeList});
        } else if (filterType === 'package') {
            this.setState({placementDropDown: placementList, lineItemDropDown: lineItemList, creativeDropDown: creativeList});
        } else if (filterType === 'line' || filterType == 'placement' || filterType == 'creative') {
            this.setState({creativeDropDown: creativeList});
        }
    }

    /**
     * This method is called on select of any filter and set the selected value in the state
     * and apply cascading based on the filter type
     * @param filterType: Type of filter
     * @param selectType: Type of select
     * @param event: Event object
     * @returns void
     */
    onSelect = (filterType, selectType, event) => {
        if(selectType === 'multiple'){
            let selectedValues = [];
            for(let i=0; i<event.detail?.length; i++) {
                selectedValues.push(event.detail[i]);
            }
            this.selectedFieldValues[filterType] = selectedValues;
        } else if(selectType === 'single'){
            this.selectedFieldValues[filterType] = event.detail;
            if(this.selectedFieldValues['budgetType'] === 'Programmatic'){
                this.selectedFieldValues['placement'] = [];
            } else if(this.selectedFieldValues['budgetType'] === 'Direct'){
                this.selectedFieldValues['line'] = [];
            }
            this.setState({
                isShowLineItem: this.selectedFieldValues['budgetType'] === 'Programmatic' || !this.selectedFieldValues['budgetType'],
                isShowPlacement: this.selectedFieldValues['budgetType'] === 'Direct' || !this.selectedFieldValues['budgetType']
            })
        }
        this.clearLevels(filterType);
        this.applyCascading(filterType);
    }

    /**
     * This method is used to clear the levels based on the filter type
     * @param filterType: Type of filter
     * @returns void
    */ 
    clearLevels = (filterType) => {
        let creativeDropDownEl = document.getElementsByClassName('placement-level-filter-container')[0].querySelector('#creativeDropdown');
        let placementDropDownEl = document.getElementsByClassName('placement-level-filter-container')[0].querySelector('#placementDropdown');
        let lineItemDropDownEl = document.getElementsByClassName('placement-level-filter-container')[0].querySelector('#lineItemDropdown');
        let packageDropDownEl = document.getElementsByClassName('placement-level-filter-container')[0].querySelector('#packageDropdown');
        let supplierDropDownEl = document.getElementsByClassName('placement-level-filter-container')[0].querySelector('#supplierDropdown');
        let budgetTypeDropDownEl = document.getElementsByClassName('placement-level-filter-container')[0].querySelector('#budgetTypeDropdown');
        let inPlatformDropDownEl = document.getElementsByClassName('placement-level-filter-container')[0].querySelector('#platformDropdown');
        let channelDropDownEl = document.getElementsByClassName('placement-level-filter-container')[0].querySelector('#channelDropdown');

        switch(filterType){
            case 'ALL':
                channelDropDownEl?.reset();
                budgetTypeDropDownEl?.reset();
            case 'channel':
                supplierDropDownEl?.reset();
            case 'budgetType':
            case 'supplier':
                inPlatformDropDownEl?.reset();
            case 'inPlatform':
                packageDropDownEl?.reset();
            case 'package':
                lineItemDropDownEl?.reset();
                placementDropDownEl?.reset();
            case 'placement':
                creativeDropDownEl?.reset();
            case 'line':
                creativeDropDownEl?.reset();
            default:
                break;
        }
        
        if(filterType === 'ALL'){
            this.selectedFieldValues = {'channel': [], 'budgetType': '', 'supplier': [], 'inPlatform': '', 'package': [], 'placement': [], 'line': [], 'creative': []};
            this.setState({isApplyDisabled: true});
            this.props.onApplyFilter(this.props.placementData, 'ALL');
        }
        else{
            let isApplyDisabled = true;
            for(let key in this.selectedFieldValues){
                if(!(['budgetType', 'inPlatform'].includes(key)) && this.selectedFieldValues[key] && this.selectedFieldValues[key].length){
                    isApplyDisabled = false;
                    break;
                }
                if(['budgetType', 'inPlatform'].includes(key) && this.selectedFieldValues[key]){
                    isApplyDisabled = false;
                    break;
                }
            }
            this.setState({isApplyDisabled: isApplyDisabled});
        }
    }

    /**
     * This method is used to apply cascading based on the filter type
     * and set the dropdown values in the state
     * @param filterType: Type of filter
     * @returns void
    */ 
    applyCascading = (filterType) => {
        let tempPackageIds = [];
        let tempLineItemIds = [];
        let tempPlacementList = [];
        let selectedPlacements = [];
        for(let i=0; i<this.filterData.length; i++) {
            if(!this.selectedFieldValues['channel']?.length || (this.selectedFieldValues['channel']?.length && this.selectedFieldValues['channel'].includes(this.filterData[i].placement_type))){
                if(!this.selectedFieldValues['supplier']?.length || (this.selectedFieldValues['supplier']?.length && this.selectedFieldValues['supplier'].includes(this.filterData[i].site))){
                    if(this.selectedFieldValues['inPlatform'] && this.selectedFieldValues['inPlatform'] === 'Yes' && !this.filterData[i].delivered_taxonomies?.length){
                        continue;
                    } else if(this.selectedFieldValues['inPlatform'] && this.selectedFieldValues['inPlatform'] === 'No' && this.filterData[i].delivered_taxonomies?.length) {
                        continue;
                    }
                    if(this.filterData[i].dropdownType === "Package"){
                        if(this.selectedFieldValues['package']?.length && this.selectedFieldValues['package'].includes(this.filterData[i].placement_taxonomy)){
                            tempPackageIds.push(this.filterData[i].id);
                            tempPlacementList.push(this.filterData[i]);
                        } else if(!this.selectedFieldValues['package']?.length){
                            if(this.selectedFieldValues['budgetType'] &&  this.selectedFieldValues['budgetType'] === 'Programmatic' && this.filterData[i].package_type === 'ProgrammaticPackage' ){
                                tempPackageIds.push(this.filterData[i].id);
                                tempPlacementList.push(this.filterData[i]);
                            } else if(this.selectedFieldValues['budgetType'] &&  this.selectedFieldValues['budgetType'] === 'Direct' && this.filterData[i].package_type === 'Package' ){
                                tempPackageIds.push(this.filterData[i].id);
                                tempPlacementList.push(this.filterData[i]);
                            } else if(!this.selectedFieldValues['budgetType']){
                                tempPackageIds.push(this.filterData[i].id);
                                tempPlacementList.push(this.filterData[i]);
                            }
                        }
                    } else if(this.filterData[i].dropdownType === "DSP"){
                        if(this.selectedFieldValues['line']?.length && this.selectedFieldValues['line'].includes(this.filterData[i]?.placement_taxonomy)){
                            tempLineItemIds.push(this.filterData[i].id);
                            tempPlacementList.push(this.filterData[i]);
                            selectedPlacements.push(this.filterData[i].id);
                        } else if(!this.selectedFieldValues['line']?.length && tempPackageIds.includes(Number(this.filterData[i].parent_id))){
                            tempLineItemIds.push(this.filterData[i].id);
                            tempPlacementList.push(this.filterData[i]);
                        }
                    } else if(this.filterData[i].dropdownType === "Placement"){
                        if(this.selectedFieldValues['placement']?.length && this.selectedFieldValues['placement'].includes(this.filterData[i]?.placement_taxonomy)){
                            tempPlacementList.push(this.filterData[i]);
                            tempLineItemIds.push(this.filterData[i].id);
                            selectedPlacements.push(this.filterData[i].id);
                        } else if(!this.selectedFieldValues['placement']?.length && tempPackageIds.includes(Number(this.filterData[i].parent_id))){
                            tempPlacementList.push(this.filterData[i]);
                        } else if(this.filterData[i].package_type === "Standalone" && (!this.selectedFieldValues['budgetType'] || this.selectedFieldValues['budgetType'] === 'Direct')){
                            tempPlacementList.push(this.filterData[i]);
                            tempLineItemIds.push(this.filterData[i].id);
                        }
                    } else if(this.filterData[i].dropdownType === "Creative"){
                        if(selectedPlacements.includes(Number(this.filterData[i].parent_id))){
                            tempPlacementList.push(this.filterData[i]);
                        } else if(!this.selectedFieldValues['creative']?.length && !selectedPlacements?.length && tempLineItemIds.includes(Number(this.filterData[i].parent_id))){
                            tempPlacementList.push(this.filterData[i]);
                        }
                    }
                }
            }
        }
        this.createDropdownsOptions(tempPlacementList, filterType);
    }

    /**
     * This method will be called on click of Apply button
     * It will filter the data based on the selected values and call the parent component method to create nested data
     * @returns void
    */
    onApply = () => {
        let finalFilterData = {};
        let finalNestedData = [];
        let creativeParentIds = [];
        let lineParentIds = [];
        let placementParentIds = [];
        // Filtering data based on the selected placements & it's parent, If applicable
        for(let i=this.filterData.length - 1; i >= 0; i--){
            if(this.selectedFieldValues['creative']?.length && this.selectedFieldValues['creative'].includes(this.filterData[i].placement_taxonomy)){
                finalFilterData[this.filterData[i].id] = this.filterData[i];
                finalNestedData.unshift(this.filterData[i]);
                creativeParentIds.push(Number(this.filterData[i].parent_id));
            } else if(this.selectedFieldValues['placement']?.length && this.selectedFieldValues['placement'].includes(this.filterData[i].placement_taxonomy)){
                finalFilterData[this.filterData[i].id] = this.filterData[i];
                finalNestedData.unshift(this.filterData[i]);
                if(this.filterData[i].package_type !== "Standalone"){
                    placementParentIds.push(Number(this.filterData[i].parent_id));
                }
            } else if(this.selectedFieldValues['line']?.length && this.selectedFieldValues['line'].includes(this.filterData[i].placement_taxonomy)){
                finalFilterData[this.filterData[i].id] = this.filterData[i];
                finalNestedData.unshift(this.filterData[i]);
                lineParentIds.push(Number(this.filterData[i].parent_id));
            } else if(creativeParentIds.includes(this.filterData[i].id) && !finalFilterData[this.filterData[i].id]){
                finalFilterData[this.filterData[i].id] = this.filterData[i];
                finalNestedData.unshift(this.filterData[i]);
                lineParentIds.push(Number(this.filterData[i].parent_id));
            } else if(this.selectedFieldValues['package']?.length && this.selectedFieldValues['package'].includes(this.filterData[i].placement_taxonomy)){
                finalFilterData[this.filterData[i].id] = this.filterData[i];
                finalNestedData.unshift(this.filterData[i]);
            } else if(lineParentIds.includes(this.filterData[i].id) && !finalFilterData[this.filterData[i].id]){
                finalFilterData[this.filterData[i].id] = this.filterData[i];
                finalNestedData.unshift(this.filterData[i]);
            } else if(placementParentIds.includes(this.filterData[i].id) && !finalFilterData[this.filterData[i].id]){
                finalFilterData[this.filterData[i].id] = this.filterData[i];
                finalNestedData.unshift(this.filterData[i]);
            }
        }

        // If only package is selected then filter all child data
        if((this.selectedFieldValues['package']?.length || this.selectedFieldValues['placement'].length || this.selectedFieldValues['line']?.length) && !this.selectedFieldValues['creative']?.length ){
            let tempPackageIds = [];
            let tempPalcementIds = [];
            let tempLineItemIds = [];
            for(let i=0; i<this.filterData.length; i++){
                if(this.selectedFieldValues['package']?.includes(this.filterData[i].placement_taxonomy)){
                    tempPackageIds.push(this.filterData[i].id);
                    if(!finalFilterData[this.filterData[i].id]){
                        finalNestedData.push(this.filterData[i]);
                    }
                } else if(this.selectedFieldValues['placement']?.includes(this.filterData[i].placement_taxonomy) || this.selectedFieldValues['line']?.includes(this.filterData[i].placement_taxonomy) ){
                    tempLineItemIds.push(this.filterData[i].id);
                    if(!finalFilterData[this.filterData[i].id]){
                        finalNestedData.push(this.filterData[i]);
                    }
                }else if(tempPackageIds.includes(Number(this.filterData[i].parent_id)) && this.filterData[i].dropdownType === "DSP"){
                    tempLineItemIds.push(this.filterData[i].id);
                    if(!finalFilterData[this.filterData[i].id]){
                        finalFilterData[this.filterData[i].id] = this.filterData[i];
                        finalNestedData.push(this.filterData[i]);
                    }
                } else if(tempPackageIds.includes(Number(this.filterData[i].parent_id)) && this.filterData[i].dropdownType === "Placement"){
                    tempLineItemIds.push(this.filterData[i].id);
                    if(!finalFilterData[this.filterData[i].id]){
                        finalFilterData[this.filterData[i].id] = this.filterData[i];
                        finalNestedData.push(this.filterData[i]);
                    }
                } else if(tempLineItemIds.includes(Number(this.filterData[i].parent_id)) && this.filterData[i].dropdownType === "Creative"){
                    if(!finalFilterData[this.filterData[i].id]){
                        finalFilterData[this.filterData[i].id] = this.filterData[i];
                        finalNestedData.push(this.filterData[i]);
                    }
                }
            }
        }

        //Checking if no placements are selected then we filter based on the selected supplier or channel
        if(Object.keys(finalFilterData).length === 0){
            let tempPlacements = {};
            let parentIds = [];
            for(let i=0; i<this.filterData.length; i++){
                tempPlacements = {};
                // condition for both supplier and channel selected
                if(this.selectedFieldValues['supplier']?.length && this.selectedFieldValues['supplier']?.includes(this.filterData[i].site) &&
                    this.selectedFieldValues['channel']?.length && this.selectedFieldValues['channel']?.includes(this.filterData[i].placement_type)){
                    tempPlacements = this.filterData[i];
                }
                else if(this.selectedFieldValues['supplier']?.length && this.selectedFieldValues['supplier']?.includes(this.filterData[i].site) && 
                    !this.selectedFieldValues['channel']?.length){
                    tempPlacements = this.filterData[i];
                } else if(!this.selectedFieldValues['supplier']?.length && this.selectedFieldValues['channel']?.length && this.selectedFieldValues['channel']?.includes(this.filterData[i].placement_type)){
                    tempPlacements = this.filterData[i];
                } else if(!this.selectedFieldValues['supplier']?.length && !this.selectedFieldValues['channel']?.length){
                    tempPlacements = this.filterData[i];
                }

                // condition for in platform
                if(this.selectedFieldValues['inPlatform'] && this.selectedFieldValues['inPlatform'] === 'Yes' && !tempPlacements.delivered_taxonomies?.length){
                    continue;
                } else if(this.selectedFieldValues['inPlatform'] && this.selectedFieldValues['inPlatform'] === 'No' && tempPlacements.delivered_taxonomies?.length) {
                    continue;
                }

                // condition for budget type
                if(tempPlacements.package_type && this.selectedFieldValues['budgetType'] &&  this.selectedFieldValues['budgetType'] === 'Programmatic' && tempPlacements.package_type === 'ProgrammaticPackage' ){
                    finalNestedData.push(this.filterData[i]);
                    parentIds.push(this.filterData[i].id);
                } else if (tempPlacements.package_type && this.selectedFieldValues['budgetType'] &&  this.selectedFieldValues['budgetType'] === 'Direct' && ['Package', 'Standalone'].includes(tempPlacements.package_type)){
                    finalNestedData.push(this.filterData[i]);
                    parentIds.push(this.filterData[i].id);
                } else if(tempPlacements.package_type && !this.selectedFieldValues['budgetType']){
                    finalNestedData.push(this.filterData[i]);
                }

                // condition for parent id, if parent id is present in the parentIds array then only we will push the child data
                if(parentIds.length && tempPlacements.parent_id && parentIds.includes(Number(tempPlacements.parent_id))){
                    finalNestedData.push(this.filterData[i]);
                    if(tempPlacements.dropdownType === 'DSP'){
                        parentIds.push(this.filterData[i].id);
                    }
                }
            }
        }
        // Filter the final nested data to remove the delivered placements from the list
        finalNestedData = finalNestedData.filter(item => item.package_type !== "Delivered");
        this.props.onApplyFilter(finalNestedData);
    }

    clearAllFilters(){
        this.props.setSpinnerCount(1);
        setTimeout(() => {
            this.clearLevels('ALL');
        }, 1000);
    }

    /**
     * Handles the mouse down event for dragging the filter popup
     * @param {React.MouseEvent} e - The mouse event object
     * @returns {void}
     */
    onMouseDown = (e) => {
        if (e.target.closest('.filterHeader')) {
            e.preventDefault();
            this.setState({ isDragging: true });
            this.initialX = e.clientX - this.xOffset;
            this.initialY = e.clientY - this.yOffset;
        }
    }

    /**
     * Handles the mouse move event for dragging the filter popup
     * @param {React.MouseEvent} e - The mouse event object
     * @returns {void}
     */
    onMouseMove = (e) => {
        if (this.state.isDragging) {
            e.preventDefault();
            
            const currentX = e.clientX - this.initialX;
            const currentY = e.clientY - this.initialY;

            this.xOffset = currentX;
            this.yOffset = currentY;

            if (this.containerRef.current) {
                this.containerRef.current.style.transform = 
                    `translate(${currentX}px, ${currentY}px)`;
            }
        }
    }

    /**
     * Handles the mouse up event to stop dragging the filter popup
     * @returns {void}
     */
    onMouseUp = () => {
        this.setState({ isDragging: false });
    }
    
    render() {
        return (
            <>
                {this.state.isShowPopup && (
                    <div 
                        className='placement-level-filter-container'
                        ref={this.containerRef}
                        onMouseDown={this.onMouseDown}
                        onMouseMove={this.onMouseMove}
                        onMouseUp={this.onMouseUp}
                        onMouseLeave={this.onMouseUp}
                        style={{cursor: this.state.isDragging ? 'grabbing' : 'default'}}
                    >
                        <>
                            <div className='filterHeader' style={{cursor: 'grab'}}>
                                <span>Filter placement levels</span>
                            </div>
                            <div className='bodyHeader'>
                                <span>Filter placement table by selected levels</span>
                            </div>
                            <div className='filterBody'>
                                <div className='clearAll'>
                                    <a onClick={this.clearAllFilters.bind(this)}>Clear All</a>
                                </div>
                                <div className='dropDownFields'>
                                    <OmniDropdownComponent
                                        id='channelDropdown' 
                                        className='filterDropdownField'
                                        multiselect
                                        typeahead
                                        searchindropdown 
                                        selectall
                                        hidefooter
                                        label="Channels"
                                        placeholder="All"
                                        onDropdownChange={(ev)=> this.onSelect('channel', 'multiple', ev)}
                                        value={this.selectedFieldValues['channel']}
                                        options={this.state.channelDropDown}>
                                    </OmniDropdownComponent>
                                </div>
                                <div className='dropDownFields'>
                                    <OmniDropdownComponent 
                                        typeahead
                                        id='budgetTypeDropdown'
                                        className='filterDropdownField'
                                        searchindropdown
                                        hidefooter
                                        label="Budget types"
                                        placeholder="All"
                                        onDropdownChange={(ev)=> this.onSelect('budgetType', 'single', ev)}
                                        value={this.selectedFieldValues['budgetType'] ? [this.selectedFieldValues['budgetType']] : []}
                                        options={['Programmatic', 'Direct']}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onMouseUp={(e) => e.stopPropagation()}
                                        onMouseLeave={(e) => e.stopPropagation()}>
                                    </OmniDropdownComponent>
                                </div>
                                <div className='dropDownFields'>
                                    <OmniDropdownComponent
                                        id='supplierDropdown'
                                        className='filterDropdownField'
                                        multiselect
                                        typeahead
                                        searchindropdown 
                                        selectall
                                        hidefooter
                                        label="Suppliers"
                                        placeholder="All"
                                        onDropdownChange={(ev)=> this.onSelect('supplier', 'multiple', ev)}
                                        value={this.selectedFieldValues['supplier']}
                                        options={this.state.supplierDropDown}>
                                    </OmniDropdownComponent>
                                </div>
                                <div className='dropDownFields'>
                                    <OmniDropdownComponent
                                        id='platformDropdown'
                                        className='filterDropdownField'
                                        searchindropdown 
                                        selectall
                                        hidefooter
                                        label="In Platform"
                                        placeholder="All"
                                        onDropdownChange={(ev)=> this.onSelect('inPlatform', 'single', ev)}
                                        value={this.selectedFieldValues['inPlatform'] ? [this.selectedFieldValues['inPlatform']] : []}
                                        options={['Yes', 'No']}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onMouseUp={(e) => e.stopPropagation()}
                                        onMouseLeave={(e) => e.stopPropagation()}>
                                    </OmniDropdownComponent>
                                </div>
                                <div className='dropDownFields'>
                                    <OmniDropdownComponent 
                                        id='packageDropdown'
                                        className='filterDropdownField'
                                        multiselect
                                        typeahead
                                        searchindropdown 
                                        selectall
                                        hidefooter
                                        label="Packages"
                                        placeholder="All"
                                        onDropdownChange={(ev)=> this.onSelect('package', 'multiple', ev)}
                                        value={this.selectedFieldValues['package']}
                                        options={this.state.packageDropDown}>
                                    </OmniDropdownComponent>
                                </div>
                                {this.state.isShowPlacement && <div className='dropDownFields'>
                                    <OmniDropdownComponent 
                                        id='placementDropdown'
                                        className='filterDropdownField'
                                        multiselect
                                        typeahead
                                        searchindropdown 
                                        selectall
                                        hidefooter
                                        label="Placements"
                                        placeholder="All"
                                        onDropdownChange={(ev)=> this.onSelect('placement', 'multiple', ev)}
                                        value={this.selectedFieldValues['placement']}
                                        options={this.state.placementDropDown}>
                                    </OmniDropdownComponent>
                                </div>}
                                {this.state.isShowLineItem && <div className='dropDownFields'>
                                    <OmniDropdownComponent 
                                        id='lineItemDropdown'
                                        className='filterDropdownField'
                                        multiselect
                                        typeahead
                                        searchindropdown 
                                        selectall
                                        hidefooter
                                        label="Line Items"
                                        placeholder="All"
                                        onDropdownChange={(ev)=> this.onSelect('line', 'multiple', ev)}
                                        value={this.selectedFieldValues['line']}
                                        options={this.state.lineItemDropDown}>
                                    </OmniDropdownComponent>
                                </div>}
                                <div className='dropDownFields'>
                                    <OmniDropdownComponent 
                                        id='creativeDropdown'
                                        className='filterDropdownField'
                                        multiselect
                                        typeahead
                                        searchindropdown 
                                        selectall
                                        hidefooter
                                        label="Creatives"
                                        placeholder="All"
                                        onDropdownChange={(ev)=> this.onSelect('creative', 'multiple', ev)}
                                        value={this.selectedFieldValues['creative']}
                                        options={this.state.creativeDropDown}>
                                    </OmniDropdownComponent>
                                </div>
                            </div>
                            <div className='footerButtons'>
                                    <button className="tertiary" onClick={this.props.onCancel}>Cancel</button>
                                    <button disabled={this.state.isApplyDisabled} onClick={this.onApply}>Apply</button>
                            </div>
                        </>
                    </div>
                )}
            </>
        )
    }
}